<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.08.02</b></p>
    <div class="ml-5 pb-4 text-orange-400">
      <div class="font-bold mt-2">New Features</div>
      <ul class="ml-4 list-disc">
        <li>Added hero dismissal — you can now dismiss heroes from your roster for Pixie Dust.</li>
        <li>Added a referral code redemption widget to the Settings menu.</li>
        <li>Added Inn opponent notifications so you know when someone has challenged you.</li>
        <li>Added Lucky and Unlucky item prefixes, which affect your party's loot find.</li>
      </ul>

      <div class="font-bold mt-2">Bug Fixes</div>
      <ul class="ml-4 list-disc">
        <li>Fixed tooltips breaking after resetting a hero's attributes.</li>
        <li>Fixed chat not scrolling to the bottom when long messages arrived.</li>
        <li>Fixed rendering glitches in the Shop and with Caverns tile text.</li>
        <li>
          Fixed Inn attack errors being silently swallowed — you'll now see why an attack isn't
          allowed.
        </li>
        <li>Fixed Inn battle logs occasionally being recorded incorrectly.</li>
      </ul>

      <div class="font-bold mt-2">QoL</div>
      <ul class="ml-4 list-disc">
        <li>Improved attribute tooltips with clearer secondary stat feedback.</li>
        <li>Improved the Inn opponents view and attack preparation screen.</li>
        <li>Press CTRL+SHIFT+U to toggle the interface on/off for clean screenshots.</li>
        <li>Faeries are now dimmed so they're less distracting.</li>
        <li>The Pixie Dust window is now fully translated.</li>
        <li>
          Various polish to the Hero Builds screen, Arena match type menu, and match overview.
        </li>
      </ul>

      <div class="font-bold mt-2">Performance</div>
      <ul class="ml-4 list-disc">
        <li>Reduced overall page weight with WebP spritesheets for faster loading.</li>
        <li>
          Audio files now load on demand instead of all at once, cutting down initial load times.
        </li>
        <li>
          Removed expensive image caching in the Shop and other canvas views to reduce memory usage
          and stuttering.
        </li>
        <li>Improved object reuse in the Caverns tile view for smoother exploration.</li>
        <li>
          Moved hero AI role ordering, payments, and other systems to a faster, more reliable
          backend pipeline.
        </li>
      </ul>
    </div>
  </div>
</template>
